import { useState, useEffect, useRef } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

const today = new Date();
const testimonials = [
  { name: "Jake M.", service: "Sports Teams", text: "I pitched 7 innings and my shoulder was absolutely destroyed. Ice Man Cryo set up right in the dugout and treated my throwing shoulder between innings. The targeted cold on my rotator cuff brought the inflammation way down. By the time I got home, the soreness was already fading. Next day I felt like I hadn't even pitched. Every pitcher needs this.", rating: 5, daysAgo: 1 },
  { name: "Alyssa R.", service: "Sports Teams", text: "I run the 400m and 4x400 relay. Between my events at regionals, Ice Man Cryo hit my quads and hamstrings right at the track. I went from barely being able to walk after the open 400 to running a personal best in the relay an hour later. Having cryo trackside after you compete is a total game changer for recovery.", rating: 5, daysAgo: 2 },
  { name: "Marcus T.", service: "Pain Relief", text: "After years of chronic knee pain, one session with Ice Man Cryo and I could feel the difference immediately. The targeted approach hit exactly where the inflammation was. No ice packs, no pills — just real relief. Already booked my next session.", rating: 5, daysAgo: 1 },
  { name: "Jennifer W.", service: "Fat Reduction", text: "I was skeptical about cryotherapy for fat reduction, but after my treatments my love handles are noticeably smaller. The fat freeze technology actually works — you can see it. My husband even noticed before I said anything!", rating: 5, daysAgo: 3 },
  { name: "Anthony B.", service: "Pain Relief", text: "Threw out my back moving furniture. Two sessions with the SubZero and I was back at work pain-free. No pills, no downtime. Just targeted cold therapy that actually works.", rating: 5, daysAgo: 2 },
  { name: "Lisa K.", service: "Fat Reduction", text: "The belly fat that wouldn't budge with diet and exercise finally started responding to the fat freeze treatments. Already seeing results and I still have sessions left. Best investment in myself I've ever made.", rating: 5, daysAgo: 4 },
  { name: "Coach Davis", service: "Sports Teams", text: "We bring Ice Man Cryo to every home game now. Our players recover faster and perform better in back-to-back games. The portable setup makes it easy — Mitch sets up right on the sideline.", rating: 5, daysAgo: 3 },
  { name: "Tyler R.", service: "Gym Partnership", text: "Having Ice Man Cryo at our gym has been incredible for member retention. People love the recovery sessions after heavy lifts. It's become a real selling point for new memberships.", rating: 5, daysAgo: 5 },
  { name: "Sandra P.", service: "Corporate Wellness", text: "We brought Ice Man Cryo to our office wellness day. Employee morale went through the roof. People were lining up for treatments. Already booking them again for next month.", rating: 5, daysAgo: 4 },
  { name: "Keisha D.", service: "Pain Relief", text: "Fibromyalgia had me in constant pain. Cryo sessions have given me relief I didn't think was possible. I can actually play with my kids again without paying for it the next day.", rating: 5, daysAgo: 6 },
  { name: "Robert H.", service: "Fat Reduction", text: "The cryolipolysis treatments are legit. Already seeing real changes in my midsection after a few fat freeze sessions. The science behind it is real and the results speak for themselves.", rating: 5, daysAgo: 5 },
  { name: "Maria G.", service: "Pain Relief", text: "My shoulder inflammation from tennis was getting worse every week. After cryo sessions targeting the joint, I'm serving pain-free again. Wish I'd found this sooner.", rating: 5, daysAgo: 7 },
  { name: "DeShawn J.", service: "Sports Teams", text: "As a college track athlete, recovery between events is everything. Having Ice Man Cryo right there after I compete means I can run my relay feeling fresh instead of broken down. The SubZero on my hamstrings is unreal.", rating: 5, daysAgo: 3 },
  { name: "Amanda F.", service: "Fat Reduction", text: "Tried everything for my thigh fat. The fat freeze sessions finally made a visible difference. You can literally see the inches coming off. Can't wait to see the full results after the cells break down over the next few weeks.", rating: 5, daysAgo: 8 },
  { name: "Brian M.", service: "Corporate Wellness", text: "Best corporate wellness event we've ever hosted. Employees are still talking about it days later. Mitch was professional, knowledgeable, and made everyone feel comfortable.", rating: 5, daysAgo: 6 },
  { name: "Crystal A.", service: "Pain Relief", text: "Carpal tunnel was making my desk job unbearable. The targeted cryo on my wrists and forearms gave me instant relief. I'm typing pain-free for the first time in months.", rating: 5, daysAgo: 9 },
  { name: "Nicole R.", service: "Fat Reduction", text: "The SubZero device targeted exactly where I needed the fat freeze — my flanks and lower belly. Already seeing changes after just a couple sessions. Absolutely worth every penny.", rating: 5, daysAgo: 7 },
  { name: "Greg P.", service: "Pain Relief", text: "Arthritis in both hands made it hard to grip anything. After my cryo session, I had significantly less swelling and pain. I can open jars again without wincing.", rating: 5, daysAgo: 10 },
  { name: "Diane H.", service: "Pain Relief", text: "Plantar fasciitis had me limping for months. Cryo sessions on my feet and I'm walking normally again. It's honestly miraculous how fast the pain went down.", rating: 5, daysAgo: 8 },
  { name: "Carlos V.", service: "Sports Teams", text: "As a marathon runner, my legs take a beating. Ice Man Cryo gets me back on the road faster than any ice bath ever could. The precision targeting is what makes the difference.", rating: 5, daysAgo: 11 },
  { name: "Tommy G.", service: "Pain Relief", text: "Construction worker with bad elbows and shoulders. Cryo sessions keep me working without pain. Can't imagine going back to popping ibuprofen every morning.", rating: 5, daysAgo: 9 },
  { name: "Vanessa L.", service: "Fat Reduction", text: "After having my second baby, nothing was working on my stomach. The fat freeze treatments are giving me my confidence back. I can already feel the difference in how my clothes fit.", rating: 5, daysAgo: 12 },
];

const serviceColors = {
  "Pain Relief": "text-amber-400 bg-amber-500/10 border-amber-500/30",
  "Fat Reduction": "text-amber-400 bg-amber-500/10 border-amber-500/30",
  "Sports Teams": "text-amber-400 bg-amber-500/10 border-amber-500/30",
  "Gym Partnership": "text-amber-400 bg-amber-500/10 border-amber-500/30",
  "Corporate Wellness": "text-amber-400 bg-amber-500/10 border-amber-500/30",
};

function getDateLabel(daysAgo) {
  if (daysAgo === 0) return "Today";
  if (daysAgo === 1) return "Yesterday";
  return `${daysAgo} days ago`;
}

const SCROLL_AMOUNT = 340;
const AUTO_SCROLL_INTERVAL = 3000;

const TestimonialsSection = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const scrollRef = useRef(null);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);

  const filters = ["All", "Pain Relief", "Fat Reduction", "Sports Teams", "Gym Partnership", "Corporate Wellness"];

  const filtered = activeFilter === "All" 
    ? testimonials 
    : testimonials.filter(t => t.service === activeFilter);

  useEffect(() => {
    if (!isAutoScrolling || !scrollRef.current) return;
    const container = scrollRef.current;
    const interval = setInterval(() => {
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 10) {
        container.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        container.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
      }
    }, AUTO_SCROLL_INTERVAL);
    return () => clearInterval(interval);
  }, [isAutoScrolling, activeFilter]);

  const scroll = (dir) => {
    setIsAutoScrolling(false);
    scrollRef.current?.scrollBy({ left: dir * SCROLL_AMOUNT, behavior: "smooth" });
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-slate-950 to-[#0a0318] relative overflow-hidden" data-testid="testimonials-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-2 mb-4">
            <span className="text-sm text-amber-300 font-medium">Real Results</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-2">
            What Our <span className="text-amber-400">Clients</span> Say
          </h2>
          <p className="text-white/70 text-lg">{testimonials.length}+ happy customers and counting</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {filters.map(f => (
            <button
              key={f}
              onClick={() => { setActiveFilter(f); setIsAutoScrolling(true); }}
              className={`px-4 py-2 rounded-full text-xs font-semibold transition-all ${
                activeFilter === f
                  ? "bg-gradient-to-r from-purple-600 to-amber-500 text-white"
                  : "bg-[#110422]/50 border border-amber-500/20 text-gray-400 hover:text-white hover:border-purple-500/50"
              }`}
              data-testid={`filter-${f.toLowerCase().replace(/\s/g, '-')}`}
            >
              {f} {f !== "All" && `(${testimonials.filter(t => t.service === f).length})`}
            </button>
          ))}
        </div>

        <div className="relative">
          <button onClick={() => scroll(-1)} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-[#110422]/80 hover:bg-amber-500/20 text-white rounded-full p-2 shadow-lg -ml-2" data-testid="testimonial-prev">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button onClick={() => scroll(1)} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-[#110422]/80 hover:bg-amber-500/20 text-white rounded-full p-2 shadow-lg -mr-2" data-testid="testimonial-next">
            <ChevronRight className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto pb-4 px-8 snap-x snap-mandatory"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none", WebkitOverflowScrolling: "touch" }}
            onMouseEnter={() => setIsAutoScrolling(false)}
            onMouseLeave={() => setIsAutoScrolling(true)}
          >
            {filtered.map((t) => {
              const colors = serviceColors[t.service] || "text-gray-400 bg-gray-500/10 border-gray-500/30";
              const cardKey = `${t.name}-${t.service}`;
              return (
                <div
                  key={cardKey}
                  className="min-w-[320px] max-w-[320px] bg-[#110422]/60 border border-amber-500/20 rounded-2xl p-6 flex-shrink-0 snap-start hover:border-amber-500/40 transition-all"
                  data-testid={`testimonial-card-${cardKey}`}
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-1">
                      {[...Array(t.rating)].map((_, j) => (
                        <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" />
                      ))}
                    </div>
                    <span className="text-[10px] text-gray-500">{getDateLabel(t.daysAgo)}</span>
                  </div>
                  <p className="text-gray-300 text-sm mb-4 leading-relaxed">"{t.text}"</p>
                  <div className="flex items-center justify-between mt-auto pt-3 border-t border-amber-500/10">
                    <span className="text-white font-semibold text-sm">{t.name}</span>
                    <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${colors}`}>
                      {t.service}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
